module.exports = __webpack_public_path__ + "static/media/laporan_konseling.f76fd022.png";